module.exports = __webpack_public_path__ + "img/Angiogenesis-BRCA_GSE176078.cefa9db7.png";